import { updateDeliveryAddress } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { UpdateDeliveryAddressServiceRequest } from './update-delivery-address.dto';
import {
  UpdateDeliveryAddressServiceRequestSchema,
  UpdateDeliveryAddressServiceResponseSchema,
} from './update-delivery-address.dto';

/**
 * 시딩 캠페인 배송지 수정 — 선택 배송지를 캠페인에 서버 영속화.
 * 신청/수락 전 라우트 왕복(SNS 채널 등록 등)에도 배송지가 유지되도록 한다. (SID-4048/4114)
 */
export const updateDeliveryAddressService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(UpdateDeliveryAddressServiceRequestSchema),
    async ({ campaignId, address }: UpdateDeliveryAddressServiceRequest): Promise<void> => {
      const apiResponse = await updateDeliveryAddress({
        campaignId,
        body: {
          deliveryAddressId: address.id,
          addressName: address.addressName,
          name: address.name,
          phone: address.phone,
          zipcode: address.zipcode,
          address1: address.address1,
          address2: address.address2,
          memo: address.memo,
        },
      });

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '배송지 수정에 실패했습니다.');
      }
    },
    validateServiceResponse(UpdateDeliveryAddressServiceResponseSchema),
  ),
);
